import * as React from "react";
import * as ReactDOM from "react-dom";

import { toHtmlElementOrNull } from "./DomHelpers";

export function useDomElementState<T extends React.ReactInstance>(): [React.RefCallback<T | null>, HTMLElement | null] {
    const [refObject, setRefObject] = React.useState<T | null>(null);
    const domElement = React.useMemo(() => toHtmlElementOrNull(ReactDOM.findDOMNode(refObject)), [refObject]);
    const setRefCallback = React.useCallback((ref: T | null) => setRefObject(ref), []);
    return [setRefCallback, domElement];
}
